import { combineReducers } from 'redux';

import app from './app';
import licensing from './licensing';
import rendering from './rendering';

export default combineReducers({ app, licensing, rendering });
